const options = {
    grabCursor: true,
    keyboard: true,
    navigation: {
        prevEl: '.js-slider-person-prev',
        nextEl: '.js-slider-person-next',
        disabledClass: 'hidden',
    },
    spaceBetween: 60,
    slidesPerView: 2,
    breakpoints: {
        768: {
            slidesPerView: 4,
            spaceBetween: 60,
            autoHeight: false,
        },
        1199: {
            slidesPerView: 6,
            spaceBetween: 60,
            autoHeight: false,
        },
    },
};

const sliderPerson = {
    init() {
        const elements = document.querySelectorAll('.js-slider-person');

        if (!elements.length) return;

        elements.forEach((element) => {
            const {autoplay, loop, speed} = element.dataset;
            if (autoplay === '1') {
                options.autoplay = {delay: 200, disableOnInteraction: false};
                options.speed = speed > 0 ? speed : 2000;
            }

            if (loop === '1') {
                options.loop = true;
            }

            const Slider = slider.default;
            this.sliderPerson = new Slider(element, options);
        });
    },
};

export default sliderPerson;
